import * as React from 'react';
export const arrowsInwardSvg = React.forwardRef(function arrowsInwardSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M.75 7.25a.75.75 0 0 1 .75-.75h3.25a.75.75 0 0 1 .75.75v3.25a.75.75 0 0 1-1.5 0V9.06l-2.47 2.47a.75.75 0 0 1-1.06-1.06L2.94 8H1.5a.75.75 0 0 1-.75-.75ZM11.53.47a.75.75 0 0 1 0 1.06L9.06 4h1.44a.75.75 0 0 1 0 1.5H7.25a.75.75 0 0 1-.75-.75V1.5a.75.75 0 0 1 1.5 0v1.44L10.47.47a.75.75 0 0 1 1.06 0Z',
    }),
  );
});
arrowsInwardSvg.defaultProps = {
  width: '12',
  height: '12',
  viewBox: '0 0 12 12',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var arrowsInward = {
  category: 'icon',
  colorable: true,
  name: 'arrowsInward',
  svg: arrowsInwardSvg,
};
